import { Fragment } from 'react';
import { getNaturalDate } from 'utils/3catinfo/dateHelper';
import { getDataUTC } from '@portal-internet/core';
import clsx from 'clsx';
import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import { getImatge } from 'components/3catinfo/Imatge';
import Text from 'components/3catinfo/Text';
import __isEmpty from 'lodash/isEmpty';
import styles from './itemautor.module.scss';

const getFotoAutor = (autor) => {
    return getImatge(autor?.imatges, 'web_autor', null, null)?.src;
};

export default function ItemAutor(props) {
    const { className, redactor, autors, mostrarTwitter = true, dataTestId, lloc, mostrarData, data } = props;
    let llistatAutors = [];

    if (!Array.isArray(autors) && autors !== '') {
        llistatAutors[0] = autors;
    } else if (!__isEmpty(autors)) {
        llistatAutors = autors;
    }

    const mesInfoVisible = llistatAutors?.length === 1;

    const fotosVisiblesNoti =
        (llistatAutors?.length === 1 && getFotoAutor(llistatAutors[0])) ||
        (llistatAutors?.length === 2 && getFotoAutor(llistatAutors[0]) && getFotoAutor(llistatAutors[1]));
    const fotosVisibles =
        className === 'capcalera_minutaminut'
            ? llistatAutors.length > 0 && llistatAutors.every((autor) => getFotoAutor(autor))
            : fotosVisiblesNoti;

    const descripcio = llistatAutors?.[0]?.carrec || llistatAutors?.[0]?.descripcio;
    const biografia = llistatAutors?.[0]?.biografia;
    const twitter = llistatAutors?.[0]?.twitter;

    const stylesAutor = clsx({
        [styles.itemAutor]: true,
        [styles[className]]: !__isEmpty(className)
    });

    const contentImatgesAutor = llistatAutors?.map((item, index) => {
        if (!__isEmpty(item.imatges) && fotosVisibles) {
            return (
                <div key={`autor-imatge-${item.id}-${index}`} className={styles.autor_foto} data-testid='autor-foto'>
                    <span>
                        <Imatge
                            imatges={item.imatges}
                            tipus='web_autor'
                            alt={item.imatges[0].alt || item.nom}
                            layout='fill'
                            objectFit='cover'
                            crop='64x64'
                        />
                    </span>
                </div>
            );
        }
    });

    return (
        <div className={stylesAutor} data-testid={dataTestId || 'item-autor'}>
            <div className={styles.autor_wrapper}>
                {fotosVisibles && <div className={styles.autor_fotos}>{contentImatgesAutor}</div>}

                <div className={styles.autor}>
                    <div
                        className={styles.autor_redactor}
                        data-testid={`${
                            __isEmpty(llistatAutors) && !__isEmpty(redactor)
                                ? `${dataTestId || 'item-autor'}-redactor`
                                : `${dataTestId || 'item-autor'}-autors`
                        }`}
                        //data-testid={`${dataTestId || 'item-autor'}-autors`}
                    >
                        {!__isEmpty(llistatAutors) &&
                            llistatAutors?.map((item, index) => {
                                const route = { slug: item.nom, id: item.id, tipologia: 'NOT_AUTOR', domini: item.domini };
                                const total = llistatAutors.length - 1;
                                return (
                                    <Fragment key={`div-${item.id}-${index}`}>
                                        <Enllac route={route} dataTestId='item-autor-enllac'>
                                            {item.nom}
                                        </Enllac>

                                        {index < total - 1 && <>,&nbsp;</>}
                                        {index === total - 1 && <>&nbsp;i&nbsp;</>}
                                    </Fragment>
                                );
                            })}
                        {!__isEmpty(redactor) && __isEmpty(llistatAutors) && redactor}
                        {lloc && <Text text={lloc} tag='span' className={styles.autor_lloc} dataTestId='item-autor-lloc' />}
                    </div>
                    {mostrarData && data && (
                        <div className={styles.dataPublicacio}>
                            <time dateTime={getDataUTC(data)}>{getNaturalDate(data)}</time>
                        </div>
                    )}
                    {descripcio && mesInfoVisible && !mostrarData && (
                        <div className={styles.autor_descripcio} data-testid='item-autor-descripcio'>
                            {descripcio}
                        </div>
                    )}
                    {biografia && mesInfoVisible && (
                        <Text text={biografia} tag='p' className={styles.autor_biografia} dataTestId='item-autor-biografia' />
                    )}
                    {twitter && mesInfoVisible && mostrarTwitter && (
                        <div className={styles.xarxes} data-testid='item-autor-twitter'>
                            <Enllac
                                className={styles.autor_xarxa}
                                href={`https://twitter.com/${twitter}`}
                                ariaLabel={`Compte X - ${twitter}`}
                                titol={twitter}
                                novaFinestra={true}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
